export default "__VITE_ASSET__Dxjiq9OV__"